import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";

import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

import Modal from "../../components/Modal";
import { setError, setSuccess } from "../../reducers/appSlice";
import ComboSiNo from "../../commons/ComboSiNo";
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import AutocompleteOrganismosSinAsignar from "../../commons/AutocompleteOrganismosSinAsignar";

const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const validationSchema = Yup.object().shape({
  organismo: Yup.number().required("Requerido"),
  mesaEntrada: Yup.string().required("Requerido"),
});

const AgregarOrganismoModal = ({ open, handleClose, grupo, agregar }) => {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const [organismo, setOrganismo] = useState(null);

  const handleSelectOrganismo = (organismo) => setOrganismo(organismo);

  const handleChangeAutocomplete = (value) => {
    formik.setFieldValue("organismo", value);
  };

  const formik = useFormik({
    initialValues: {
      organismo: "",
      mesaEntrada: "N",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setSaving(true);
        await agregar({ ...values, grupo: grupo });
        dispatch(setSuccess("Organismo agregado"));
        handleClose();
      } catch (error) {
        dispatch(setError(error.message));
      } finally {
        setSaving(false);
      }
    },
    onReset: () => {},
  });

  useEffect(() => {
    if (!organismo) return;
    formik.setFieldValue("organismo", organismo?.id);
  }, [organismo]);

  useEffect(() => {
    if (!open) {
      setSaving(false);
      setOrganismo(null);
      formik.handleReset();
    }
  }, [open]);

  return (
    <Modal open={open} handleClose={handleClose} size="md">
      <form
        id="formAgregarOrganismo"
        name="formAgregarOrganismo"
        onSubmit={formik.handleSubmit}
        onReset={formik.handleReset}
        noValidate
        autoComplete="off"
      >
        <Box mb={2}>
          <Typography variant="titulo">Agregar organismo:</Typography>
        </Box>
        {/* <input type="hidden" id="id" name="id" value={formik.values.id} /> */}
        <Row container spacing={1}>
          <Grid item lg={8} xs={12}>
            {/* <Box display="flex" flexDirection="row">
              <input
                type="hidden"
                id="organismo"
                name="organismo"
                value={formik.values.organismo}
              />
              <TextField
                id="organismoDesc"
                name="organismoDesc"
                label="Organismo"
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={organismo?.descOrgCompleta || ""}
                error={
                  formik.touched.organismo && Boolean(formik.errors.organismo)
                }
                helperText={formik.touched.organismo && formik.errors.organismo}
              />
              <BuscadorOrganismo
                resultado={handleSelectOrganismo}
                // mostrar="boton"
                accion="consulta"
              />
            </Box> */}
            <AutocompleteOrganismosSinAsignar
              name="organismo"
              error={
                formik.touched.organismo && Boolean(formik.errors.organismo)
              }
              helperText={formik.touched.organismo && formik.errors.organismo}
              onChange={handleChangeAutocomplete}
              value={formik.values.organismo}
              label="Organismos sin asignar"
              fullWidth
            />
          </Grid>
          <Grid item lg={4} xs={12}>
            <ComboSiNo
              label={"Es mesa de entrada"}
              name="mesaEntrada"
              error={
                formik.touched.mesaEntrada && Boolean(formik.errors.mesaEntrada)
              }
              helperText={
                formik.touched.mesaEntrada && formik.errors.mesaEntrada
              }
              onChange={formik.handleChange}
              value={formik.values.mesaEntrada}
              fullWidth
            />
          </Grid>
        </Row>

        <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button
            sx={{ m: 1 }}
            variant="verde"
            color="primary"
            endIcon={<AddIcon />}
            type="submit"
            disabled={saving}
          >
            {saving ? "Agregando..." : "Agregar"}
          </Button>
          <Button
            variant="plata"
            type="button"
            endIcon={<ClearIcon />}
            sx={{ m: 1 }}
            onClick={handleClose}
          >
            Cancelar
          </Button>
        </Box>
      </form>
    </Modal>
  );
};

export default AgregarOrganismoModal;
